// Feature flag defaults from env (inlined to avoid circular dep with @ping/configs)
const _ENABLE_COMMODITIES = process.env.NEXT_PUBLIC_ENABLE_COMMODITIES === 'true';
const _ENABLE_STOCKS = process.env.NEXT_PUBLIC_ENABLE_STOCKS === 'true';
const _ENABLE_FOREX = process.env.NEXT_PUBLIC_ENABLE_FOREX === 'true';

// Feature flags only gate on production and testnet; everything is enabled on develop/staging/local
const _ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT as string | undefined;
const _IS_GATED_ENV = _ENVIRONMENT === 'production' || _ENVIRONMENT === 'testnet';

export const isMiax = () => typeof window !== 'undefined' && localStorage.getItem('company') === 'miax';
export const isNasdaq = () => typeof window !== 'undefined' && localStorage.getItem('company') === 'nasdaq';
export const isPingCommodities = () => typeof window !== 'undefined' && localStorage.getItem('company') === 'ping';
export const isStock = () => typeof window !== 'undefined' && localStorage.getItem('company') === 'stock';
export const isForex = () => typeof window !== 'undefined' && localStorage.getItem('company') === 'forex';
export const isCommodities = () => !!(isMiax() || isNasdaq() || isPingCommodities());

/**
 * Get the current exchange type
 * @returns 'crypto' | 'commodity' | 'stock' | 'forex' | 'miax' | 'nasdaq'
 */
export const getExchangeType = () => {
  if (typeof window === 'undefined') return 'crypto';
  const company = localStorage.getItem('company');
  return company || 'crypto';
};

/**
 * Get the display label for the current exchange type
 */
export const getExchangeLabel = () => {
  if (isMiax()) return 'MIAX Commodities';
  if (isNasdaq()) return 'Nasdaq Commodities';
  if (isPingCommodities()) return 'Digital Commodities';
  if (isStock()) return 'Digital Stocks';
  if (isForex()) return 'Digital Forex';
  return 'Crypto Currency';
};

/**
 * Check if a given exchange type is enabled.
 * Crypto is always enabled.
 * For others: env var is the default, localStorage can override to true (for admin testing).
 *
 * @param type - The exchange type key: 'crypto' | 'ping' | 'stock' | 'forex'
 */
export const isExchangeTypeEnabled = (type: string): boolean => {
  if (type === 'crypto') return true;

  // On develop, staging, and local — all exchange types are enabled
  if (!_IS_GATED_ENV) return true;

  if (typeof window === 'undefined') {
    if (type === 'ping') return _ENABLE_COMMODITIES;
    if (type === 'stock') return _ENABLE_STOCKS;
    if (type === 'forex') return _ENABLE_FOREX;
    return false;
  }

  // env default OR localStorage override (production/testnet only)
  if (type === 'ping') return _ENABLE_COMMODITIES || localStorage.getItem('enableCommodities') === 'true';
  if (type === 'stock') return _ENABLE_STOCKS || localStorage.getItem('enableStocks') === 'true';
  if (type === 'forex') return _ENABLE_FOREX || localStorage.getItem('enableForex') === 'true';
  return false;
};
